import CardCarousel from 'Presentation/Components/CardCarousel'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import clsx from 'clsx'

const ProductBoxCardPreview: React.FC<{
	featurePicturePath: string
	nameTh: string
	nameEn: string
	disabled?: boolean
	clickable?: boolean
	onClickCard?: () => void
}> = ({ featurePicturePath, nameEn, nameTh, onClickCard, clickable, disabled }) => {
	return (
		<div
			className={clsx('card border border-kumopack-grey-200 h-100 w-75 product-card-carousel', {
				'bg-kumopack-grey-100': disabled,
				'bg-kumopack-base-white shadow': !disabled,
				'pointer-events-none': disabled && !clickable,
			})}
			onClick={() => {
				if (clickable && onClickCard) onClickCard()
			}}>
			<div className="card-img h-75 d-flex align-items-center justif-content-center">
				<img
					src={featurePicturePath ?? '/media/icons/kumopack/default-placeholder-transparent.png'}
					alt=""
					className="img-fluid"
					onError={(e: any) => {
						e.target.onerror = null
						e.target.src = '/media/icons/kumopack/default-placeholder-transparent.png'
					}}
					style={{ userSelect: 'none', pointerEvents: 'none' }}
				/>
			</div>

			<div className="card-body">
				<div className="row gy-1">
					<div
						className={clsx('col-12 fs-7 fw-bold text-kumopack-error-700 text-start', {
							'd-none': !disabled,
							'd-block': disabled,
						})}>
						สร้างแล้ว
					</div>

					<div className="col-12 fs-6 fw-bold text-kumopack-grey-700 text-start">{nameEn}</div>

					<div className="col-12 fs-1 fw-bold text-kumopack-grey-700 text-start">{nameTh}</div>
				</div>
			</div>
		</div>
	)
}

interface Props {
	title: string
	products: {
		id: number
		featurePicturePath: string
		nameTh: string
		nameEn: string
		disabled?: boolean
	}[]
	onClickCard?: (id: number) => void
	customActive?: number
	setCustomActive?: (idx: number) => void
}

const ProductionLineSelection: React.FC<Props> = ({
	title,
	products,
	onClickCard,
	customActive,
	setCustomActive,
}) => {
	return (
		<>
			<div className="row gy-5 mb-10">
				<div className="col-12">
					<h3 className="text-kumopack-grey-600 my-4">{title}</h3>
				</div>

				<div
					className="col-12"
					style={{ height: products.length === 0 ? 'auto' : !isMobileDevice() ? '60vh' : '100vh' }}>
					<div className="h-100 overflow-hidden">
						<div className="card-body h-100">
							{products.length === 0 && (
								<div className="text-kumopack-grey-500 text-center fs-4">ไม่พบข้อมูล</div>
							)}

							{products.length > 0 && (
								<CardCarousel customActive={customActive} setCustomActive={setCustomActive}>
									{products.map((p, i) => (
										<ProductBoxCardPreview
											key={`product-card-carousel-${i}`}
											{...p}
											onClickCard={() => onClickCard && onClickCard(p.id)}
										/>
									))}
								</CardCarousel>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default ProductionLineSelection
